import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import WCDProgramPage from "./pages/WCDProgramPageEnhanced";
import ObjectivePage from "./pages/ObjectivePage";
import BeneficiaryAnalysisSolution from "./pages/BeneficiaryAnalysisSolution";
import DownloadPage from "./pages/DownloadPage";
import AVTDashboard from "./pages/dashboards/AVTDashboard";
import AVTDashboardV2 from "./pages/dashboards/AVTDashboardV2";
import THRDashboard from "./pages/dashboards/THRDashboard";
import THRDashboardEnhanced from "./pages/dashboards/THRDashboardEnhanced";
import FRSDashboard from "./pages/dashboards/FRSDashboard";
import FRSAuthDashboard from "./pages/dashboards/FRSAuthDashboard";
import HCMDashboard from "./pages/dashboards/HCMDashboard";
import HCMEnhancedDashboard from "./pages/dashboards/HCMEnhancedDashboard";
import InfrastructureDashboard from "./pages/dashboards/InfrastructureDashboard";
import PURNADashboard from "./pages/dashboards/PURNADashboard";
import GrowthMonitoringDashboard from "./pages/dashboards/GrowthMonitoringDashboard";
import EnrollmentDropoutDashboard from "./pages/dashboards/EnrollmentDropoutDashboard";
import DetailedDashboard from "./pages/DetailedDashboard";
import GenerateReportPage from "./pages/GenerateReportPage";
import SetKPIsPage from "./pages/SetKPIsPage";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/objective" element={<ObjectivePage />} />
            <Route path="/beneficiary-analysis" element={<BeneficiaryAnalysisSolution />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/wcd-programs/:slug" element={<WCDProgramPage />} />
            <Route path="/dashboards/avt" element={<AVTDashboardV2 />} />
            <Route path="/dashboards/avt-old" element={<AVTDashboard />} />
            <Route path="/dashboards/thr" element={<THRDashboardEnhanced />} />
            <Route path="/dashboards/thr-old" element={<THRDashboard />} />
            <Route path="/dashboards/frs" element={<FRSAuthDashboard />} />
            <Route path="/dashboards/frs-old" element={<FRSDashboard />} />
            <Route path="/dashboards/hcm" element={<HCMEnhancedDashboard />} />
            <Route path="/dashboards/hcm-old" element={<HCMDashboard />} />
            <Route path="/dashboards/infrastructure" element={<InfrastructureDashboard />} />
            <Route path="/dashboards/purna" element={<PURNADashboard />} />
            <Route path="/dashboards/growth-monitoring" element={<GrowthMonitoringDashboard />} />
            <Route path="/dashboards/enrollment-dropout" element={<EnrollmentDropoutDashboard />} />
            <Route path="/dashboard/:metricId" element={<DetailedDashboard />} />
            <Route path="/generate-report" element={<GenerateReportPage />} />
            <Route path="/set-kpis" element={<SetKPIsPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;